// extracted by mini-css-extract-plugin
export var videosGrid = "VideosGrid-module--videosGrid--Dtm2j";
export var featuredVideo = "VideosGrid-module--featuredVideo--9af1e";
export var videoTiles = "VideosGrid-module--videoTiles--aMZu0";